import { render, staticRenderFns } from "./AnswerCkeditor.vue?vue&type=template&id=1654756a&scoped=true"
import script from "./AnswerCkeditor.vue?vue&type=script&lang=js"
export * from "./AnswerCkeditor.vue?vue&type=script&lang=js"
import style0 from "./AnswerCkeditor.vue?vue&type=style&index=0&id=1654756a&prod&lang=less"
import style1 from "./AnswerCkeditor.vue?vue&type=style&index=1&id=1654756a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1654756a",
  null
  
)

export default component.exports